import { Base } from "@/components/Navigation/Buttons/AccountButton/accountButton.base";
import { Content } from "@/components/Navigation/Buttons/AccountButton/components/content/content";
import { useAccountButtonContext } from "@/components/Navigation/Buttons/AccountButton/context/accountButton.context";

export const AccountButton = Object.assign(Base, {
    useContext: useAccountButtonContext,
    Content: Content
});
